export { UrlParser, default } from './url-parser';
//# sourceMappingURL=index.js.map